module.exports = __webpack_public_path__ + "img/yunhangjilu.c7d606f6.png";